import { otpHost, mscHost } from './../config/env.conf';
const baseUrl = otpHost + '/#/';
import { getMscSrc } from './routerHelper';

interface IRouteItem {
    name: string;
    path: string;
    component: any;
    children?: Array<IRouteItem>;
    meta?: IMeta;
}

interface IMeta {
    title: string;
    src?: string;
    type?: string;
    notMenu?: boolean;
    noAuth?: boolean;
}

const FinanceBizMap = {
    'dzd': {
        'jiujing': 'zeus/mtp',
        'chepiao': 'travel/car',
        'gty': 'travel/group',
        'jijiu': 'travel/planehotel'
    },
    'fp': {
        'jiujing': 'zeus',
        'chepiao': 'car',
        'gty': 'group',
        'jijiu': 'planehotel'
    },
    'QaA': ['jiujing', 'gty'],
    'paymentRecords': ['chepiao', 'gty']
};

const DataBizMap = {
    fwsj: ['gty']
}

const bizLineIdMap = {
    'ticket': 2,
    'jiujing': 4,
    'jijiu': 6,
    'chepiao': 7,
    'gty': 3,
    'wenchuang': 1
};

const bizLineNameMap = {
    'ticket': 'ticket',
    'jiujing': 'sceneHotel',
    'jijiu': 'airlineTicket',
    'chepiao': 'carTicket',
    'gty': 'packageTour',
    'wenchuang': 'wenchuang'
};

export default class RouteBuilder {
    constructor(private bizLineName: string, public viewWrapper: any, public innerFrame: any) {

    }

    createRoute(name: string, path: string, component: any, meta?: IMeta): any {
        let routeMeta = Object.assign({ type: this.bizLineName }, meta || {});
        return {
            name: this.bizLineName + name,
            path,
            component,
            meta: routeMeta
        };
    }

    createRouteFromItem(routeItem: IRouteItem) {
        let route = null;
        let component = routeItem.component;
        if (!component) {
            if (routeItem.children && routeItem.children.length) {
                component = this.viewWrapper;
            } else if (routeItem.meta && routeItem.meta.src) {
                component = this.innerFrame;
            } else {
                component = this.viewWrapper;
            }
        }
        route = this.createRoute(routeItem.name, routeItem.path, component, routeItem.meta);
        if (routeItem.children && routeItem.children.length) {
            route.children = [];
            routeItem.children.forEach((childRouteItem) => {
                route.children.push(this.createRouteFromItem(childRouteItem));
            });
        }
        return route;
    }

    createRouteItem(name: string, path: string, title: string, src?: string, fulPath?: boolean, component?: any, meta?: any): any {
        return this.createRouteFromItem({
            name,
            path,
            component,
            meta: Object.assign({
                title,
                src: src ? fulPath ? src : `${baseUrl + this.bizLineName + src}` : null
            }, meta || {})
        });
    }

    createNativeRouteItem(name: string, path: string, title: string, component: any, meta?: any): any {
        return this.createRouteItem(name, path, title, null, false, component, meta);
    }

    static buildBasicInfo(builer: RouteBuilder, orderPrefix?: string, homeapgeCompoent?: any, hasConfirmOrder?: boolean) {
        //
        let productPreFix = '/product/';
        let orderPreFix = orderPrefix || '/order/';
        let home = builer.createRouteItem('home', '', '首页', '/', false, builer.innerFrame, { icon: 'turbo-ui-home' });
        if (homeapgeCompoent) {
            home = builer.createNativeRouteItem('home', '', '首页', homeapgeCompoent, { icon: 'turbo-ui-home', bizLineId: bizLineIdMap[builer.bizLineName] });
        }
        let product = builer.createRouteItem('product', 'product', '产品管理', null, false, builer.viewWrapper, { icon: 'turbo-ui-setting' });
        let productNew = builer.createRouteItem('productNew', 'new', '新建产品', productPreFix + 'new');
        let productList = builer.createRouteItem('productList', 'list', '产品列表', productPreFix + 'list');
        product.children = [productNew, productList];
        let order = builer.createRouteItem('order', 'gtyOrder', '订单管理', null, false, builer.viewWrapper, { icon: 'assignment' });
        let orderList = builer.createRouteItem('orderlist', 'list', '管理订单', orderPreFix + 'list-order');
        let confirmOrderList = null;
        if (hasConfirmOrder) {
            confirmOrderList = builer.createRouteItem('confirmOrderlist', 'confirmOrderList', '待确认订单', orderPrefix + 'confirmOrderList');
        }
        let noPayList = builer.createRouteItem('nopayList', 'nopaylist', '追单列表', orderPreFix + 'list-workorder');
        order.children = [orderList, noPayList];
        if (confirmOrderList) {
            order.children.push(confirmOrderList);
        }
        return [home, product, order];
    }

    static buildMyInfo(builer: RouteBuilder, noBizMenu: boolean) {
        let preFix = '/info/';
        let result = null;
        if (!noBizMenu) {
            result = builer.createRouteItem('myinfo', 'info', '我的信息', null, false, builer.viewWrapper, { icon: 'ios-person' });
        }
        let authInfo = builer.createRouteItem('authInfo', 'authInfo', '认证信息', preFix + 'auth-info');
        let suppilerInfo = builer.createRouteItem('suppilerInfo', 'suppilerInfo', '供应商信息', preFix + 'supplier');
        let contractInfo = builer.createRouteItem('contractInfo', 'contractInfo', '合同信息', preFix + 'contract-list');
        let menuAry = [authInfo, suppilerInfo, contractInfo];
        if (!noBizMenu) {
            result.children = menuAry;
        } else {
            result = menuAry;
        }
        return result;
    }

    static buildTicketMyInfo(builer: RouteBuilder) {
        let preFix = '/info/';
        let myInfo = builer.createRouteItem('myinfo', 'info', '我的信息', null, false, builer.viewWrapper, { icon: 'ios-person' });
        let authInfo = builer.createRouteItem('authInfo', 'auth-info', '认证信息', preFix + 'auth-info');
        let suppilerInfo = builer.createRouteItem('suppilerInfo', 'supplier', '供应商信息', preFix + 'supplier');
        let contractInfo = builer.createRouteItem('contractInfo', 'contract-list', '合同信息', preFix + 'contract-list');
        myInfo.children = [authInfo, suppilerInfo, contractInfo];
        return myInfo
    }

    static buildPromotionInfo(builer: RouteBuilder) {
        let preFix = '/promotion/';
        let promotionInfo = builer.createRouteItem('promotionInfo', 'promotion', '营销中心', null, false, builer.viewWrapper, { icon: 'turbo-ui-fire' });
        let createSelfPromotion = builer.createRouteItem('createSelfPromotion', 'createSelfPromotion', '自助活动创建', preFix + 'deal-list');
        let selfPromotionList = builer.createRouteItem('selfPromotionList', 'list', '自助活动查询', preFix + 'self-promotion-list');
        promotionInfo.children = [createSelfPromotion, selfPromotionList];
        return promotionInfo;
    }

    static buildFinanceInfo(builder: RouteBuilder) {
        let isFulPath = true;
        let preFix = '/msc/fe/index.html#/';
        let meta = { withPadding: true };
        let financeInfo = builder.createRouteItem('financeInfo', 'finance', '财务管理', null, false, builder.viewWrapper, { icon: 'turbo-ui-money' });
        let settlement = builder.createRouteItem('settlement', 'settlement', '结算对账单', getMscSrc(`${mscHost + preFix}statement/${FinanceBizMap.dzd[builder.bizLineName]}`), isFulPath, null, meta);
        let invoiceList = builder.createRouteItem('invoicelist', 'invoicelist', '发票管理', getMscSrc(`${mscHost}/msc/biz/travel/invoice/queryPartnerInvoiceModel?buzParty=TRAVEL&bizline=${FinanceBizMap.fp[builder.bizLineName]}&sellType=mtp`), isFulPath, null, meta);
        financeInfo.children = [settlement, invoiceList];
        if (FinanceBizMap.QaA.includes(builder.bizLineName)) {
            financeInfo.children.push(builder.createRouteItem('financeQAA', 'qaa', '财务问答', getMscSrc(`${mscHost + preFix}question/travel/`), isFulPath, null, meta));
        }
        if (FinanceBizMap.paymentRecords.includes(builder.bizLineName)) {
            financeInfo.children.push(builder.createRouteItem('paymentRecords', 'records', '付款记录', getMscSrc(`${mscHost + preFix}paytrace/${FinanceBizMap.dzd[builder.bizLineName]}`), isFulPath, null, meta));
        }
        return financeInfo;
    }

    static buildDataSummary(builer: RouteBuilder, operatingDataCompoent: any, productDataComponent: any, ServeData?: any) {
        let dataSummaryInfo = builer.createRouteItem('dataSummaryInfo', 'reporter', '数据分析', null, false, builer.viewWrapper, { icon: 'turbo-ui-bargraph' });
        let operatingData = builer.createNativeRouteItem('operatingData', 'operating', '经营数据', operatingDataCompoent);
        let productData = builer.createNativeRouteItem('productData', 'product', '商品数据', productDataComponent);
        dataSummaryInfo.children = [operatingData, productData];
        if (DataBizMap.fwsj.includes(builer.bizLineName)) {
            dataSummaryInfo.children.push(builer.createNativeRouteItem('serveData', 'srver', '服务数据', ServeData));
        }
        return dataSummaryInfo;
    }

    static buildReviewList(builer: RouteBuilder, commentComponet: any) {
        let reviewList = builer.createNativeRouteItem('reviewlist', 'reviews', '评价管理', commentComponet, { icon: 'turbo-ui-recommend' });
        return reviewList;
    }

    static buildReviewDetail(builer: RouteBuilder, commentComponet: any) {
        return builer.createNativeRouteItem('reviewDetail', 'review/:id?/:name?', '评价详情', commentComponet, { notMenu: true, noAuth: true, activeName: builer.bizLineName + 'reviewlist' });
    }

    static buildQaA(builer: RouteBuilder) {
        let preFix = '/qa/';
        let qaqManage = builer.createRouteItem('qaq', 'qa', '问答管理', null, false, builer.viewWrapper, { icon: 'turbo-ui-comment' });
        let qaqSummary = builer.createRouteItem('summary', 'qa-collect', '问答汇总', preFix + 'qa-collect');
        let qaqList = builer.createRouteItem('list', 'qa-query', '问答查询', preFix + 'qa-query');
        qaqManage.children = [qaqSummary, qaqList];
        return qaqManage;
    }

    static buildXAXY(builder: RouteBuilder, component: any) {
        let xgxy = builder.createNativeRouteItem('academy', 'academy', '西瓜学院', component, { bizLineId: bizLineIdMap[builder.bizLineName], icon: 'turbo-ui-college' });
        return xgxy;
    }

    static buildGZZX(builder: RouteBuilder) {
        let gzzx = builder.createRouteItem('policyrule', 'policyrule', '规则中心', `${baseUrl}notification/policyrule/${bizLineNameMap[builder.bizLineName]}`, true, null, { icon: 'turbo-ui-hammer' });
        return gzzx;
    }
}


// WEBPACK FOOTER //
// ./src/router/routeBuilder.ts